/* eslint-disable react/prop-types */
import React from 'react';

import Appointment from './Appointment';
import ScheduleUtils from './ScheduleUtils';

import './AppointmentTooltip.scss';

export default function AppointmentTooltipComponent({
  itemData,
  schedulerRef,
  reasonsOptions,
  setTaskRescheduling,
  removeAppointmentByIndex,
}) {
  const appointmentData = ScheduleUtils.readTooltipAppointmentRecord(itemData);

  return (
    <Appointment
      itemData={{ data: { appointmentData } }}
      className="appointment-tooltip-task"
      screen="appointmentTooltip"
      reasonsOptions={reasonsOptions}
      schedulerRef={schedulerRef}
      setTaskRescheduling={setTaskRescheduling}
      removeAppointmentByIndex={removeAppointmentByIndex}
    />
  );
}
